import React from "react";
import { SOCIAL } from "../../constants";

function HeroCTA() {
  return (
    <p className="hero-cta">
      <a href={SOCIAL.email}>nl545@cornell.edu</a>
      <span aria-hidden="true"> · </span>
      <a href={SOCIAL.linkedin} target="_blank" rel="noreferrer">
        LinkedIn
      </a>
      <span aria-hidden="true"> · </span>
      <a href={SOCIAL.github} target="_blank" rel="noreferrer">
        GitHub
      </a>
    </p>
  );
}

export default HeroCTA;
